import React from 'react';
import { Box, Typography, List, ListItem, ListItemText } from '@mui/material';
import { PieChart, Pie, Cell } from 'recharts';
import './DateLastContacted.css'; 
import { useNavigate, useLocation } from 'react-router-dom';

const DateLastContacted = ({ totalclients, lastContacted }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const COLORS = ['#F54BB1', '#F4C107', '#03BC72', '#572AF1'];

  const ranges = [
    { key: 'range_0_2_weeks', name: '0-2 Weeks' },
    { key: 'range_3_4_weeks', name: '3-4 Weeks' },
    { key: 'range_5_7_weeks', name: '5-7 Weeks' },
    { key: 'range_8_plus_weeks', name: '2+ Months' },
  ];

  const data = ranges.map(({ key, name }, i) => ({
    name,
    value: lastContacted?.[key] ?? 0,
    color: COLORS[i],
    key,
  }));

  const handleFilterClick = (key) => {
  const searchParams = new URLSearchParams(location.search);
  if (searchParams.get('lastContactedRange') === key) return;
  searchParams.set('lastContactedRange', key);
  searchParams.delete('page'); 

  navigate({
    pathname: '/clients',
    search: searchParams.toString(),
  });
};

  return (
    <Box className="dlc-container">
      <Typography variant="h6" className="dlc-title" sx={{ fontWeight: 'bold' }}>
        Date Last Contacted
      </Typography>

      <Box className="dlc-inner-box">
        <Box className="dlc-pie-wrapper">
          <PieChart width={150} height={150}>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={70}
              fill="#8884d8"
              dataKey="value"
              stroke="none"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>

          <Box className="dlc-center-text">
            <Typography variant="h4" fontWeight="bold">
              {totalclients ?? 0}
            </Typography>
            <Typography variant="body2">Clients</Typography>
          </Box>
        </Box>

        <List className="dlc-list">
          {data.map((item, index) => (
            <ListItem key={index} className="dlc-list-item"
            onClick={() => handleFilterClick(item.key)}
            sx={{
                cursor: 'pointer',
                userSelect: 'none',
                '&:hover': { backgroundColor: 'rgba(87, 42, 241, 0.1)', color: '#572AF1' }
              }}
              title={`Filter clients last contacted: ${item.name}`}
              >
              <Box className="dlc-dot" style={{ backgroundColor: item.color }} />
              <ListItemText
                primary={
                  <Box className="dlc-list-entry">
                    <Typography component="span" className="dlc-value"  fontWeight="bold">{item.value}</Typography>
                    <Typography component="span">{item.name}</Typography>
                  </Box>
                }
              />
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default DateLastContacted;
